exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UsingOffer_using-offer__expiration_25Hm {\n    margin-bottom: 20px;\n  }\n", ""]);

// exports
exports.locals = {
	"using-offer__expiration": "UsingOffer_using-offer__expiration_25Hm"
};